
import { createClient } from '@supabase/supabase-js';

// Using credentials provided in the original request snippet
const SUPABASE_URL = 'https://vinxbbpboupirnyxwghz.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpbnhiYnBib3VwaXJueXh3Z2h6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEwMDk2NTMsImV4cCI6MjA3NjU4NTY1M30.K1DuhjnTP2KMY-72vlqN12bpmpSm2UluFOmFUOAsaaU';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
